<template>
  <v-dialog v-model="dialog" fullscreen persistent>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white" @click="cancel" class="mr-4">mdi-arrow-left</v-icon>
        <v-toolbar-title>XẾP THỜI KHÓA BIỂU</v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-card outlined class="pa-4 my-4 elevation-0">
          <v-row>
            <v-col cols="12" md="6">
              <AutocompleteClass
                v-model="classData"
                clear-icon="mdi-close"
                placeholder="Lớp"
                outlined
                dense
                large
                deletable-chips
                hide-details
              />
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex justify-end">
                <v-btn
                  class="search-button"
                  color="#0D47A1"
                  @click="onFilterChanged"
                  outlined
                  :disabled="!classData || !classData.id"
                >
                  Chọn xếp
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <!-- time table -->
        <TimeTableBlankView type="class" v-if="!searchClass" :createSchedule="true" />
        <v-row v-else>
          <!-- drag -->
          <v-col
            cols="12"
            md="2"
            :style="{ 'max-height': windowHeight - 56 - 74 - 68 - 32 + 'px !important', 'overflow-y': 'scroll' }"
          >
            <v-row>
              <v-col v-for="teaching in teachings" :key="teaching.id" cols="12" md="6">
                <v-tooltip max-width="250px" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <drag class="drag" :tag="'span'" :transfer-data="{ teaching: teaching }">
                        <div class="subjectGroup-name mt-1 truncate-text">
                          <span>
                            {{ teaching | _get('subjectGroup.title') + '\n' }}
                          </span>
                          <span v-if="$_get(teaching, 'data.subName')">({{ $_get(teaching, 'data.subName') }})</span>
                        </div>
                        <div>
                          {{ teaching.teacher | getTeacher }}
                        </div>
                      </drag>
                    </div>
                  </template>
                  <span>{{ teaching | getTooltipContent }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <!-- drop -->
          <v-col
            cols="12"
            md="10"
            :style="{ 'max-height': windowHeight - 56 - 74 - 68 - 32 + 'px !important', 'overflow-y': 'scroll' }"
          >
            <table>
              <tr style="height: 50px">
                <th></th>
                <th>Thứ 2</th>
                <th>Thứ 3</th>
                <th>Thứ 4</th>
                <th>Thứ 5</th>
                <th>Thứ 6</th>
                <th>Thứ 7</th>
              </tr>
              <tr v-for="index in 12" :key="index" :class="index != 1 && index != 7 ? 'daySection' : ''">
                <td v-if="index === 1 || index === 7" colspan="7" class="text-center font-weight-bold py-2">
                  {{ index === 1 ? 'Sáng' : 'Chiều' }}
                </td>
                <template v-else>
                  <td class="text-center">Tiết {{ getIndex(index) }}</td>
                  <td v-for="day in 6" :key="day" style="position: relative">
                    <v-icon
                      class="removeButton"
                      v-if="
                        $_get(slotData[`${getIndex(index)}-${day}`], 'slot.status') !== 'inactive' &&
                          slotData[`${getIndex(index)}-${day}`] &&
                          slotData[`${getIndex(index)}-${day}`].teaching
                      "
                      small
                      color="grey"
                      @click="clickRemoveSlot(index, day)"
                      >close</v-icon
                    >
                    <drop
                      class="drop"
                      :class="{ over }"
                      :tag="'span'"
                      @dragover="over = true"
                      @dragleave="over = false"
                      @drop="handleDrop($event, index, day)"
                    >
                      <div
                        class="subjectGroup-name mt-2"
                        v-if="$_get(slotData[`${getIndex(index)}-${day}`], 'slot.status') !== 'inactive'"
                      >
                        {{ slotData[`${getIndex(index)}-${day}`] | _get('teaching.subjectGroup.title') }}
                      </div>
                      <div v-if="$_get(slotData[`${getIndex(index)}-${day}`], 'slot.status') !== 'inactive'">
                        {{ slotData[`${getIndex(index)}-${day}`] | _get('teaching.teacher') | getTeacher }}
                      </div>
                    </drop>
                  </td>
                </template>
              </tr>
            </table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider v-if="searchClass"></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="!searchClass" depressed color="primary" class="ma-2 mr-2 white--text" @click="save"
          >Lưu thời khóa biểu</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import { Drag, Drop } from 'vue-drag-drop'
import { get, chunk } from 'lodash'
import TimeTableBlankView from '@/modules/timeTable/TimeTableBlankView.vue'
import { Slot } from '../../plugins/api'

export default {
  components: {
    AutocompleteClass,
    Drag,
    Drop,
    TimeTableBlankView
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      classData: null,
      over: false,
      slotData: {},
      classSlots: {},
      searchClass: false,
      windowHeight: window.innerHeight
    }
  },
  computed: {
    ...mapState('timeTable', ['teachings', 'slots'])
  },
  methods: {
    ...mapActions('timeTable', ['fetchTeachings', 'fetchClassSchedule', 'createSlot', 'updateSlot', 'removeSlot']),

    async handleDrop(data, i, day) {
      const index = this.getIndex(i)
      if (data.teaching.teacher && data.teaching.teacher.id) {
        const slotParams = {
          index,
          day,
          'teaching.teacher': data.teaching.teacher.id,
          status_ne: 'inactive',
          _limit: 1
        }
        if (this.slotData[`${index}-${day}`].slot && this.slotData[`${index}-${day}`].slot.id) {
          slotParams['id_ne'] = this.slotData[`${index}-${day}`].slot.id
        }

        const slots = await Slot.fetch(slotParams)
        if (slots.length > 0) {
          this.$alert.error(`Giáo viên ${data.teaching.teacher.name} đã được phân công vào tiết này`)
          return
        }
      }

      this.over = false
      const slot = {
        slot: { ...this.slotData[`${index}-${day}`].slot, status: 'active' },
        teaching: data.teaching,
        index,
        day,
        rawSubjectTeacherId: this.slotData[`${index}-${day}`].rawSubjectTeacherId
      }
      this.slotData[`${index}-${day}`] = slot
    },
    async save() {
      const slots = Object.values(this.slotData)
      try {
        this.$loading.active = true
        const groups = chunk(slots, 3)
        for (let subSlots of groups) {
          await Promise.all(
            subSlots.map(async object => {
              if (!get(object, 'index')) return

              if ((!object.slot || !object.slot.id) && get(object, 'teaching.subject.id')) {
                // create
                const data = {
                  class: get(this.classData, 'id'),
                  grade: get(this.classData, 'grade.id'),
                  subject: get(object, 'teaching.subject.id'),
                  teacher: get(object, 'teaching.teacher.id'),
                  index: object.index,
                  day: object.day,
                  teaching: get(object, 'teaching.id'),
                  indexDay: object.index + '-' + object.day,
                  status: 'active'
                }
                return this.createSlot(data)
              } else {
                if (!object.teaching && object.slot && object.slot.id) {
                  // soft remove
                  // return this.removeSlot(object.slot.id)
                  return this.updateSlot({
                    id: object.slot.id,
                    status: 'inactive'
                  })
                } else {
                  const currentValue = get(object, 'teaching.subject.id') + '-' + get(object, 'teaching.teacher.id')
                  if (
                    object.slot.status === 'active' ||
                    (object.rawSubjectTeacherId !== currentValue && object.slot && object.slot.id)
                  ) {
                    // update
                    return this.updateSlot({
                      id: object.slot.id,
                      subject: get(object, 'teaching.subject.id'),
                      teacher: get(object, 'teaching.teacher.id'),
                      teaching: get(object, 'teaching.id'),
                      status: 'active'
                    })
                  }
                }
              }
            })
          )
        }

        this.$alert.success('Cập nhật thời khóa biểu thành công')
        this.dialog = false
        this.reset()
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    clickRemoveSlot(i, day) {
      const index = this.getIndex(i)

      this.slotData = {
        ...this.slotData,
        [`${index}-${day}`]: {
          slot: this.slotData[`${index}-${day}`].slot,
          teaching: null,
          index,
          day,
          rawSubjectTeacherId: this.slotData[`${index}-${day}`].rawSubjectTeacherId
        }
      }
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    async onFilterChanged() {
      this.searchClass = true
      this.$loading.active = true
      const query = {
        class: get(this.classData, 'id'),
        subject_null: false,
        _sort: 'subject.title:ASC',
        _limit: -1
      }
      await this.fetchClassSchedule({
        ...query
      })
      this.slotData = { ...this.slots }
      this.$loading.active = false
    },
    getIndex(index) {
      return index < 7 ? index - 1 : index - 2
    },
    reset() {
      this.searchClass = false
      this.classData = null
    },
    onResize() {
      this.windowHeight = window.innerHeight
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  },
  filters: {
    getTeacher(teacher) {
      if (teacher) {
        const nameArr = teacher.name.split(' ')
        const name = nameArr[nameArr.length - 1]
        if (teacher.gender === 'female') return `C.${name}`
        if (teacher.gender === 'male') return `T.${name}`
        return name
      }

      return null
    },
    getTooltipContent(teaching) {
      if (teaching.teacher && teaching.teacher.name) {
        let prefix = 'GV. '
        if (teaching.teacher.gender === 'female') prefix = 'Cô '
        if (teaching.teacher.gender === 'male') prefix = 'Thầy '
        return get(teaching, 'subjectGroup.title') + ' - ' + prefix + teaching.teacher.name
      } else {
        return get(teaching, 'subjectGroup.title')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  padding: 40px 90px;
  line-height: 1.5;
}
.section {
  margin-top: 30px;
  margin-bottom: 50px;
}
.drag {
  box-sizing: border-box;
  display: inline-block;
  // border-radius: 4px;
  width: 70px;
  height: 70px;
  background: #f1f1f1;
  position: relative;
  text-align: center;
  cursor: move;
}
.drop {
  box-sizing: border-box;
  display: inline-block;
  width: 100%;
  height: 60px;
  position: relative;
  text-align: center;
  border-radius: 0px;
  z-index: 1;
}

/* time table */
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  white-space: nowrap;
  border: 1px solid #ddd;
}
.daySection {
  height: 61px;
}
.removeButton {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  z-index: 2;
}
.subjectGroup-name {
  font-weight: 500;
}
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
